import angular, { IOnInit } from "angular"
import { IReportGroup } from "../../interfaces/IReportGroup"
import { getReportUrl } from "../../utils"

export class SingleReportDownloaderController implements IOnInit {
  private static $inject: string[] = ['$scope']

  private reportGroup: IReportGroup | undefined
  private entityId: number | undefined

  private reportViews: ReportView[] = []
  private defaultUrl: string = ''

  constructor(private readonly $scope: angular.IScope) { }

  $onInit(){
    this.$scope.$watch(() => this.reportGroup, (newValue) => {
      this.reportGroupChanged(newValue)
    })
  }

  private reportGroupChanged(newValue: IReportGroup | undefined) {
    this.reportViews = []

    if (!(newValue && this.entityId)) { return }

    const id = this.entityId
    this.defaultUrl = getReportUrl(newValue, undefined, id)
    this.reportViews = Object.entries(newValue.Reports).map(entry => {
      const [reportName, report] = entry
      return {
        name: reportName,
        url: this.entityId ? getReportUrl(newValue, reportName, id) : '',
        description: report.Description
      }
    })
  }
}

class ReportView {
  name: string = ''
  url: string = ''
  description: string = ''
}